<div class="landing-hero-wrapper">
  <div class="landing-hero-background" [style.background-color]="color">
    <picture class="landing-hero-image">
      <source *ngIf="imageXl" media="(min-width: 1200px)" type="image/webp" [srcset]="imageXl" />
      <source *ngIf="altImageXl" media="(min-width: 1200px)" type="image/png" [srcset]="altImageXl" />

      <source *ngIf="imageLg" media="(min-width: 768px)" type="image/webp" [srcset]="imageLg" />
      <source *ngIf="altImageLg" media="(min-width: 768px)" type="image/png" [srcset]="altImageLg" />

      <source *ngIf="imageMd" media="(min-width: 576px)" type="image/webp" [srcset]="imageMd" />
      <source *ngIf="altImageMd" media="(min-width: 576px)" type="image/png" [srcset]="altImageMd" />

      <source *ngIf="imageSm" media="(min-width: 0px)" type="image/webp" [srcset]="imageSm" />
      <source *ngIf="altImageSm" media="(min-width: 0px)" type="image/png" [srcset]="altImageSm" />

      <img *ngIf="altImageXl" [src]="altImageXl" alt="Brunch" />
    </picture>
  </div>
  <section class="section landing-hero-section">
    <div class="container landing-hero-container">
      <header class="landing-hero-header">
        <a routerLink="/" class="landing-hero-logo" aria-label="BOX"></a>
        <div class="landing-hero-login-container">
          <a
            id="cosid_md_login"
            class="landing-hero-login my-account dropdown"
            [attr.disabled]="disabledLogin"
            (click)="onConnectClick()"
          >
            <span class="cosid-span" data-toggle="dropdown_cosid">{{ 'connect_register' | translate }}</span>
          </a>
        </div>
      </header>
      <div class="landing-hero-content-wrapper">
        <div class="landing-hero-content">
          <h1 class="landing-hero-keywords">
            <landing-hero-words [words]="keywords"></landing-hero-words>
          </h1>
          <landing-hero-location></landing-hero-location>
          <mat-spinner
            *ngIf="disabledLogin"
            class="landing-hero-login-spinner"
            diameter="24"
            strokeWidth="3"
          ></mat-spinner>
        </div>
      </div>
      <landing-promo-banner #promoBannerRef *ngIf="promoBanner" [promoBanner]="promoBanner"></landing-promo-banner>
    </div>
  </section>
</div>
